export const BRAND_FAVICON_PATH = '/tonaltutor-tab-icon-20260715.png'

export function installBrandFavicon() {
  document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((link) => link.remove())

  const icon = document.createElement('link')
  icon.id = 'tonaltutor-favicon'
  icon.rel = 'icon'
  icon.type = 'image/png'
  icon.sizes = '64x64'
  icon.href = BRAND_FAVICON_PATH
  document.head.append(icon)
}
